// extracted by mini-css-extract-plugin
module.exports = {"reservationDetails":"App_reservationDetails__1C-Pf","backTitle":"App_backTitle__342JF","center":"App_center__q_WxN","title":"App_title__1Q3k0"};